import { Component, OnInit, Input } from '@angular/core';
import { BreadcrumbService } from '../services/breadcrumb.service';

@Component({
    selector: 'app-dynamic-breadcrumb',
    templateUrl: './dynamic-breadcrumb.component.html',
    styleUrls: ['./dynamic-breadcrumb.component.scss'],
    standalone: false
})
export class DynamicBreadcrumbComponent implements OnInit {

  public breadCrumbText = "";
  @Input() public sectionTitle = "";
  @Input() public myUser = "";


  constructor(private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {

    let currentPosition = this.breadcrumbService.getCurrentZone(this.sectionTitle, this.myUser);
    this.breadCrumbText = currentPosition
  }


}
